// Mirrors Task::CATEGORIES in the API. The report filters group tasks by these.
export const TASK_CATEGORIES = [
  { value: 'service_delivery', label: 'Service Delivery', variant: 'primary' },
  { value: 'service_delivery_support', label: 'Service Delivery Support Tasks', variant: 'info' },
  { value: 'management_asw', label: 'Management/ASW Tasks', variant: 'warning' },
  { value: 'other', label: 'Other (e.g. Office Closed)', variant: 'secondary' },
];

export function taskCategory(value) {
  return TASK_CATEGORIES.find((category) => category.value === value) || null;
}
